export const social = {
    facebook: {
        label: "Facebook",
        href: "#",
        target: "external",
    },
    instagram: {
        label: "Instagram",
        href: "#",
        target: "external",
    },
    twitter: {
        label: "Twitter",
        href: "#",
        target: "external",
    },
};

export const legal = {
    terms: {
        label: "利用規約",
        href: "#",
        target: "external",
    },
    privacy: {
        label: "プライバシーポリシー",
        href: "#",
        target: "external",
    },
    sell: {
        label: "私の個人情報を販売したり共有したりしないでください",
        href: "#",
        target: "external",
    },
    choices: {
        label: "広告の選択",
        href: "#",
        target: "external",
    },
};

export const a11y = {
    skip: {
        label: "コンテンツにスキップします",
    },
};
